import DS from 'ember-data';

export default DS.JSONAPISerializer.extend(
{
	keyForAttribute(key) { return key; },
	keyForRelationship(key) { return key; },
	extractRelationships(modelClass, resourceHash)
	{
		var eventId = resourceHash.attributes.EventId;
		delete resourceHash.attributes.EventId;
		if(eventId != null)
		{
			resourceHash.relationships =  {
				"EventId":
				{
					"data":
					{
						"type": "event",
						"id": String(eventId)
					}
				}
			};
		}
		return this._super(...arguments);
	},
	serializeBelongsTo(snapshot, json, relationship) 
	{
	    var key = relationship.key;
	    var belongsTo = snapshot.belongsTo(key);

	    key = this.keyForRelationship ? this.keyForRelationship(key, "belongsTo", "serialize") : key;

		if(belongsTo == null)
		{
			json.attributes[key] = null;
		}
		else
		{
			json.attributes[key] = belongsTo.id;
		}
	}
});